// Import all JS files in this folder excluding index.js
const modules = import.meta.glob(['./*.js', '!./index.js'], { eager: true });

const MagoEnums = {
  install(app) {
    app.config.globalProperties.MagoEnums = this;
  }
};

function loadModules() {
  for (const path in modules) {
    Object.assign(MagoEnums, modules[path]);
  }
}

loadModules();

if (import.meta.hot) {
  import.meta.hot.accept((newModules) => {
    // reset (opzionale ma consigliato)
    for (const key of Object.keys(MagoEnums)) {
      if (key !== 'install') delete MagoEnums[key];
    }

    // ricarica
    loadModules();
  });
}

export default MagoEnums;